export default class DtoCMSQuestionValue {
    constructor(obj) {
        this.idSurvey = obj.idSurvey // Option[Long],
        this.idQuestion = obj.idQuestion // Option[Long],
        this.idAnswer = obj.idAnswer // Option[Long],
        this.answerDescription = obj.answerDescription // Option[String]
    }
}
